import React from 'react';
import { I_IQPlayerGallery, I_IQPlayerGallerySettings } from '../interfaces';

interface IIqpsImagesProps {
    item: I_IQPlayerGallery;
    iQPlayerGallerySettings: I_IQPlayerGallerySettings;
}

const IqpsImages= ( props: IIqpsImagesProps ) => {

    const item = props?.item

    return (
        <div className="text-center rounded-xl overflow-hidden">
            <img className="bg-gray-400" src={ item?.img } alt="" />
            <div className="text-gray-700 py-4 px-4" style={{
                backgroundColor: item?.bgColor
            }}>
                <div className="text-xl font-bold" style={{
                    color: item?.color
                }}> { item?.title }</div>

                <div className="text-sm"  style={{
                    color: item?.color
                }}> {item?.title}</div>

                <div className="text-base"  style={{
                    color: item?.color
                }}> "Voice ReGen made our remote interviews sound like they were done in person. Game-changer!"</div>
            </div>
        </div>
    );
};

export default IqpsImages;